import React from 'react';
import PropTypes from 'prop-types';
import { Button, SvgIcon } from '@mui/material';
import CheckCircleIcon from '../../../../icons/check-circle.svg?react';

import './ButtonInput.scss';

export default function ButtonInput(props) {
  return (
    <Button
      variant={props.value ? 'outlined' : 'contained'}
      color="primary"
      className={`shadow button-input ${props.value ? 'active' : 'inactive'} ${props.mobileWide ? 'wide-sm' : ''}`}
      onClick={props.onClick}
      aria-pressed = {props.value}
      aria-labelledby= {props.title}
    >
      <span>
        <SvgIcon fontSize="large" component={props.icon} />
        <h2 className="title">{props.title}</h2>
        <p className="subtitle">{props.subtitle}</p>
        <SvgIcon component={CheckCircleIcon} color="primary" className="check" />
      </span>
    </Button>
  );
}

ButtonInput.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object
  ]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  mobileWide: PropTypes.bool
};
